import { render, staticRenderFns } from "./Herramientas.vue?vue&type=template&id=650e0674"
import script from "./Herramientas.vue?vue&type=script&lang=js"
export * from "./Herramientas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports